define([
	"dojo/_base/declare",
	"csi/xml"
], function(declare,xml) {

	return declare(null, {

		toWriter: function() {
			// summary: Add BOMSection attribute to MaterialPlanPlacements that are part of a BOMSectionDefinition
			// This code is similar to code found in PartMaterialBOMSectionMixin.

			// Call superclass to create this.m_urlNode CNL, then see if we need to change the DSSection attribute
			this.inherited(arguments);

			if (this._groupResults) {
				this._groupResults.every(function(groupResult, index) {
					var groupUrl = groupResult.groupValue;

					if (groupResult.level && groupResult.level.groupSpec) {
						var groupId = groupResult.level.groupSpec.heading.m_id;

						if (groupId == "DSSection") {
							// We only set the group value on the new node if the group is by DSSection on PartMaterial.
							// To avoid going through the loop again, we return false to break out of the loop.
							this.m_writer.changeNode(this.m_urlNode).changeAttribute(groupId, xml.ATTR_REF, groupUrl);
							return false;
						}
					}
				}, this);
			}
		}

	});
});
